/// <reference path="../../lib/tsd.d.ts" />
/// <reference path="./utils.ts" />

/**
 * Handles the stream container and everything inside it
 */
export class StreamPanel
{
	/**
	 * @param $root  A node that contains the stream wrapper
	 */
	constructor(private $root : JQuery)
	{
	}

	/**
	 * Places this component to the specified coordinates with the specified size
	 */
	public place(x : number, y : number, w : number, h : number)
	{
		this.$root.css({
			top: y,
			left: x,
			width: w,
			height: h
		});
	}

	/**
	 * Clears placement css from this component
	 */
	public clearPlace()
	{
		this.$root.css({
			top: "",
			left: "",
			bottom: "",
			right: "",
			width: "",
			height: ""
		});
	}
}
